// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".additional-info-form input::placeholder,.additional-info-form textarea::placeholder{font-style:italic}\n", ""]);
// Exports
module.exports = exports;
